import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const DOCS_DOCUMENT_LANG: {
  DOCUMENT_SIGN_COMMON_DECLINE_NOUN: MvnCodeFE;
  DOCUMENT_FOLDER_INVALID_ACCESS: MvnCodeFE;
  DOCUMENT_FOLDER_INVALID_ACCESS_DESCRIPTION: MvnCodeFE;
  DOCUMENT_CANCELED_SIGN: MvnCodeFE;
  DOCUMENT_CANCELED_SIGN_DESCRIPTION: MvnCodeFE;
  DOCUMENT_CREATE_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_UPLOAD_FILE_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_UPLOAD_FILE_COUNT_LABEL: MvnCodeFE;
  DOCUMENT_UPLOAD_PDF_FILE_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_TITLE_LABEL: MvnCodeFE;
  DOCUMENT_VERSION_LABEL: MvnCodeFE;
  DOCUMENT_AVAILABLE_STORAGE: MvnCodeFE;
  DOCUMENT_AVAILABLE_STORAGE_ARCHIVER: MvnCodeFE;
  DOCUMENT_ARCHIVER_STORAGE_TOTAL: MvnCodeFE;
  DOCUMENT_ARCHIVER_STORAGE_USAGE: MvnCodeFE;
  DOCUMENT_FILE_LABEL: MvnCodeFE;
  DOCUMENT_FILE_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_FILE_LIMIT_SIZE_DESCRIPTION: MvnCodeFE;
  DOCUMENT_FILE_DESCRIPTION: MvnCodeFE;
  DOCUMENT_ADDITIONAL_MESSAGE_DESCRIPTION: MvnCodeFE;
  DOCUMENT_FILE_TYPE_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_FILE_SUCC: MvnCodeFE;
  DOCUMENT_FILE_FAIL: MvnCodeFE;
  DOCUMENT_FILE_NOT_ALLOWED: MvnCodeFE;
  DOCUMENT_FILE_EXCEEDS_MAX_SIZE: MvnCodeFE;
  DOCUMENT_FILE_UPLOAD_ZERO_BYTES: MvnCodeFE;
  DOCUMENT_FILE_INVALID_EXTENSION: MvnCodeFE;
  DOCUMENT_FILE_PDF_CONVERTING_TITLE: MvnCodeFE;
  DOCUMENT_FILE_PDF_CONVERTING_FAIL_TITLE: MvnCodeFE;
  DOCUMENT_FILE_PDF_CONVERTING_FAIL_DESC: MvnCodeFE;
  DOCUMENT_FILE_PDF_RETRY_CONVERT_LABEL: MvnCodeFE;
  DOCUMENT_FILE_UPLOAD_DND_HELPER_DESCRIPTION: MvnCodeFE;
  DOCUMENT_FILE_TABLE_EMPTY_DND_DESCRIPTION: MvnCodeFE;
  DOCUMENT_FILE_MAX_COUNT_HELPER_TEXT: MvnCodeFE;
  DOCUMENT_FILE_MULTIPLE_UPLOAD_NAME_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_FILE_UPLOAD_EXTENSION_HELPER_TEXT: MvnCodeFE;
  DOCUMENT_FILE_UPLOAD_SIZE_HELPER_TEXT: MvnCodeFE;
  DOCUMENT_FILE_UPLOAD_RESULT_SUMMARY_TITLE: MvnCodeFE;
  DOCUMENT_FILE_UPLOAD_FAIL_REASON_INVALID_EXTENSION: MvnCodeFE;
  DOCUMENT_FILE_UPLOAD_FAIL_REASON_EXCEEDS_MAX_SIZE: MvnCodeFE;
  DOCUMENT_FILE_UPLOAD_FAIL_REASON_PASSWORD_PROTECTED: MvnCodeFE;
  PDF_RETRY_CONVERT_REQUEST_SUCCESS_TOAST: MvnCodeFE;
  PDF_RETRY_CONVERT_REQUEST_FAIL_TOAST: MvnCodeFE;
  DOCUMENT_CREATE_SUCC: MvnCodeFE;
  DOCUMENT_CREATE_FAIL: MvnCodeFE;
  DOCUMENT_DOWNLOAD_SUCC: MvnCodeFE;
  DOCUMENT_DOWNLOAD_FAIL: MvnCodeFE;
  DOCUMENT_ESIGN_HEADER: MvnCodeFE;
  DOCUMENT_ESIGN_CREATE_HEADER: MvnCodeFE;
  DOCUMENT_ESIGN_CREATE_DESCRIPTION: MvnCodeFE;
  DOCUMENT_ESIGN_SIGNATURE_HEADER: MvnCodeFE;
  DOCUMENT_ESIGN_SIGNATURE_HEADER_SIGNED: MvnCodeFE;
  DOCUMENT_ESIGN_SIGNATURE_HEADER_CANCELED: MvnCodeFE;
  DOCUMENT_ESIGN_SIGNATURE_HEADER_DECLINED: MvnCodeFE;
  DOCUMENT_START_ESIGN_BUTTON: MvnCodeFE;
  DOCUMENT_REQUEST_ESIGN_BUTTON: MvnCodeFE;
  DOCUMENT_REQUEST_ESIGN_BUTTON_WITH_COUNT: MvnCodeFE;
  DOCUMENT_REQUEST_ESIGN_BUTTON_WITH_COUNT_UNLIMITED: MvnCodeFE;
  DOCUMENT_REQUEST_ESIGN_DESCRIPTION: MvnCodeFE;
  DOCUMENT_CREATE_ESIGN_BUTTON: MvnCodeFE;
  DOCUMENT_CANCEL_ESIGN_BUTTON: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_BUTTON: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_ENTER_BUTTON: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_ENTER_NOTI: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_REASON_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_REASON_SELECT_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_REASON_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_REASON_APPROVER: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_REASON_REVIEWER: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_REASON_CONFIRM_WRITE: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_REASON_OWNER: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_REASON_OTHER: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_EMAIL_VERIFICATION_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_EMAIL_VERIFICATION_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_TABLE_EMPTY_TITLE: MvnCodeFE;
  DOCUMENT_SIGN_DECLINE_BUTTON: MvnCodeFE;
  DOCUMENT_SIGN_CANCEL_BUTTON: MvnCodeFE;
  DOCUMENT_SIGN_DOWNLOAD_BUTTON: MvnCodeFE;
  DOCUMENT_SIGN_DOWNLOAD_BUTTON_GENERATING: MvnCodeFE;
  DOCUMENT_SIGN_DOWNLOAD_REPORT_BUTTON: MvnCodeFE;
  DOCUMENT_SIGN_DOWNLOAD_MERGED_BUTTON: MvnCodeFE;
  DOCUMENT_SIGN_SEE_DOCUMENT_BUTTON: MvnCodeFE;
  DOCUMENT_SIGN_SIGNATURE_ENTER: MvnCodeFE;
  DOCUMENT_SIGN_STAMP_ENTER: MvnCodeFE;
  DOCUMENT_SIGN_STAMP_DESCRIPTION: MvnCodeFE;
  DOCUMENT_ADD_SIGNER_BUTTON: MvnCodeFE;
  DOCUMENT_NTH_SIGNER_LABEL: MvnCodeFE;
  DOCUMENT_NTH_INVESTIGATOR_LABEL: MvnCodeFE;
  DOCUMENT_NTH_INVESTIGATOR_SHORT_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_FIELD_SETTING_HEADER: MvnCodeFE;
  DOCUMENT_SIGN_REQ_FIELDS_FULFILL: MvnCodeFE;
  DOCUMENT_SIGN_SIGNATURE_MISSING: MvnCodeFE;
  DOCUMENT_SIGN_ZEROBYTES_IMAGE: MvnCodeFE;
  DOCUMENT_SIGN_AGREE_AND_PROCEED: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_SIGN_DECLINE_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_SIGN_CANCEL_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_AGREEMENT_EFFECT: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_AGREEMENT_ORIGINAL: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_AGREEMENT_ETC_PREFIX: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_AGREEMENT_ETC_LINK: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_AGREEMENT_ETC_SUFFIX: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_DECLINE_CONFIRM: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_DECLINE_WARNING: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_CANCEL_CONFIRM: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_CANCEL_BULK_DESC: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_CANCEL_WARNING: MvnCodeFE;
  DOCUMENT_SIGN_CANCEL: MvnCodeFE;
  DOCUMENT_SIGN_MERGING: MvnCodeFE;
  DOCUMENT_SIGN_REQUEST_NOUN: MvnCodeFE;
  DOCUMENT_SIGN_REQUEST_SUCC: MvnCodeFE;
  DOCUMENT_SIGN_REQUEST_FAIL: MvnCodeFE;
  DOCUMENT_SIGN_CREATE_SUCC: MvnCodeFE;
  DOCUMENT_SIGN_CREATE_FAIL: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_SUCC: MvnCodeFE;
  DOCUMENT_SIGN_ESIGN_FAIL: MvnCodeFE;
  DOCUMENT_SIGN_DECLINE_SUCC: MvnCodeFE;
  DOCUMENT_SIGN_DECLINE_FAIL: MvnCodeFE;
  DOCUMENT_SIGN_CANCEL_SUCC: MvnCodeFE;
  DOCUMENT_SIGN_CANCEL_FAIL: MvnCodeFE;
  DOCUMENT_SIGN_NAME: MvnCodeFE;
  DOCUMENT_SIGN_NAME_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_EMAIL: MvnCodeFE;
  DOCUMENT_SIGN_EMAIL_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_COMPANY: MvnCodeFE;
  DOCUMENT_SIGN_COMPANY_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_TITLE: MvnCodeFE;
  DOCUMENT_SIGN_TITLE_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_SIGNATURE: MvnCodeFE;
  DOCUMENT_SIGN_PHONE: MvnCodeFE;
  DOCUMENT_SIGN_ORGANIZATION_RESEARCH_INFO_TITLE: MvnCodeFE;
  DOCUMENT_SIGN_DATE: MvnCodeFE;
  DOCUMENT_SIGN_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_PRO_PLAN: MvnCodeFE;
  DOCUMENT_SIGN_OPT_GXP_COMPLY: MvnCodeFE;
  DOCUMENT_SIGN_OPT_ADVANCED_MODE: MvnCodeFE;
  DOCUMENT_SIGN_OPT_NO_REQUIRE_VERIFICATION: MvnCodeFE;
  DOCUMENT_SIGN_OPT_REQUIRE_EMAIL_VERIFICATION: MvnCodeFE;
  DOCUMENT_SIGN_OPT_REQUIRE_PERSONAL_IDENTIFICATION: MvnCodeFE;
  DOCUMENT_SIGN_OPT_ASSIGN_PROGRAMMATICALLY: MvnCodeFE;
  DOCUMENT_SIGN_OPT_ESIGN_AUTOMATICALLY: MvnCodeFE;
  DOCUMENT_SIGN_OPT_SILENT_MODE: MvnCodeFE;
  DOCUMENT_SIGN_OPT_RESPONSIVE_ITEM_INDEX: MvnCodeFE;
  DOCUMENT_SIGN_OPT_RESPONSIVE_ITEM_GROUP: MvnCodeFE;
  DOCUMENT_SIGN_OPT_ADD_RESPONSIVE_ITEM: MvnCodeFE;
  DOCUMENT_SIGN_OPT_ADD_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_OPT_RESPONSIVE_ITEM_MISSING_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_OPT_RESPONSIVE_ITEM_MISSING_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_OPT_RESPONSIVE_ITEM_INVALID_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_OPT_RESPONSIVE_ITEM_INVALID_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_OPT_STAMP_API_URL_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_OPT_STAMP_API_URL_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_OPT_STAMP_API_TIMING_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_OPT_STAMP_API_TIMING_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_OPT_ADD_STAMP_API: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_REASON: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_SIGN_START_PREFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_SIGN_START_SUFFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_DELIVERED_PREFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_DELIVERED_SUFFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_REMIND_PREFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_REMIND_SUFFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_OPENED_PREFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_REFERRER_OPENED_PREFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_REFERRER_OPENED_SUFFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_OPENED_SUFFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_SIGNED_PREFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_SIGNED_SUFFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_DECLINED_PREFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_DECLINED_SUFFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_CANCELED_PREFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_CANCELED_SUFFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_CANCEL_REASON_PREFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_CANCEL_REASON_SUFFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_SIGN_EXPIRED_PREFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_SIGN_EXPIRED_SUFFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_SIGN_END_PREFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_SIGN_END_SUFFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_SIGN_DECLINE_PREFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_SIGN_DECLINE_SUFFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_SIGN_CANCEL_PREFIX: MvnCodeFE;
  DOCUMENT_SIGN_HISTORY_SIGN_CANCEL_SUFFIX: MvnCodeFE;
  DOCUMENT_SIGN_CERTIFICATE_DESC_DIGEST: MvnCodeFE;
  DOCUMENT_SIGN_CERTIFICATE_DESC_DIGEST_HASH: MvnCodeFE;
  DOCUMENT_SIGN_CERTIFICATE_DESC_HASH_CHAIN: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_CANCEL_REASON: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_CHANGE_DOC: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_CHANGE_SIGNEE: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_DELETE_SIGNEE: MvnCodeFE;
  DOCUMENT_SIGN_DIALOG_OTHER: MvnCodeFE;
  DOCUMENT_SIGN_ECONSENT_STATUS_TITLE: MvnCodeFE;
  DOCUMENT_SIGN_ECONSENT_BUTTON: MvnCodeFE;
  DOCUMENT_SIGN_FAILED_IDENTIFY_SIGNATURE: MvnCodeFE;
  DOCUMENT_ECONSENT_SIGNATURE_HEADER: MvnCodeFE;
  DOCUMENT_ECONSENT_SIGNATURE_HEADER_SIGNED: MvnCodeFE;
  DOCUMENT_ECONSENT_SIGNATURE_HEADER_CANCELED: MvnCodeFE;
  DOCUMENT_ECONSENT_SIGNATURE_HEADER_DECLINED: MvnCodeFE;
  DOCUMENT_SIGN_ECONSENT_REASON_APPROVER_SIGNER: MvnCodeFE;
  DOCUMENT_SIGN_ECONSENT_REASON_APPROVER_INVESTIGATOR: MvnCodeFE;
  DOCUMENT_ECONSENT_DECLINE_BUTTON: MvnCodeFE;
  DOCUMENT_ECONSENT_CANCEL_BUTTON: MvnCodeFE;
  DOCUMENT_ECONSENT_DOWNLOAD_BUTTON: MvnCodeFE;
  DOCUMENT_ECONSENT_DOWNLOAD_BUTTON_GENERATING: MvnCodeFE;
  DOCUMENT_ECONSENT_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_ECONSENT_DECLINE_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_ECONSENT_CANCEL_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_ECONSENT_DIALOG_AGREEMENT_EFFECT: MvnCodeFE;
  DOCUMENT_ECONSENT_DIALOG_AGREEMENT_ORIGINAL: MvnCodeFE;
  DOCUMENT_ECONSENT_DIALOG_AGREEMENT_ETC_LINK: MvnCodeFE;
  DOCUMENT_ECONSENT_DIALOG_DECLINE_WARNING: MvnCodeFE;
  DOCUMENT_ECONSENT_DIALOG_CANCEL_DESC: MvnCodeFE;
  DOCUMENT_ECONSENT_DIALOG_CANCEL_WARNING: MvnCodeFE;
  DOCUMENT_ECONSENT_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_REQ: MvnCodeFE;
  DOCUMENT_ECONSENT_OPT_RESPONSIVE_ITEM_INDEX: MvnCodeFE;
  DOCUMENT_ECONSENT_OPT_ADD_RESPONSIVE_ITEM_GROUP: MvnCodeFE;
  DOCUMENT_ECONSENT_OPT_ADD_OPTION: MvnCodeFE;
  DOCUMENT_ECONSENT_CREATE_ICF_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_ECONSENT_ADD_SUBJECTS_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_ECONSENT_ADD_SUBJECT_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_ECONSENT_SUBJECT_LIST_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_ECONSENT_DOWNLOAD_LIST_DIALOG_BUTTON: MvnCodeFE;
  DOCUMENT_EXCEL_DOWNLOAD_DESCRIPTION: MvnCodeFE;
  DOCUMENT_ECONSENT_ADD_SUBJECT_LIMIT: MvnCodeFE;
  DOCUMENT_ECONSENT_SUBJECTS_VALIDATE: MvnCodeFE;
  DOCUMENT_ECONSENT_ADD_SUBJECTS_SUCC: MvnCodeFE;
  DOCUMENT_ECONSENT_ADD_SUBJECTS_FAIL: MvnCodeFE;
  DOCUMENT_ECONSENT_ADD_SUBJECT_FAIL: MvnCodeFE;
  DOCUMENT_ECONSENT_CREATE_STUDY_NAME_MISSING: MvnCodeFE;
  DOCUMENT_ECONSENT_CREATE_ICF_SECTION_HEADER: MvnCodeFE;
  DOCUMENT_ECONSENT_CREATE_ICF_SECTION_BUTTON: MvnCodeFE;
  DOCUMENT_ECONSENT_CREATE_ICF_SUCC: MvnCodeFE;
  DOCUMENT_ECONSENT_CREATE_ICF_FAIL: MvnCodeFE;
  DOCUMENT_ECONSENT_CREATE_ICF_NAME_MISSING: MvnCodeFE;
  DOCUMENT_ECONSENT_CREATE_ICF_VERSION_MISSING: MvnCodeFE;
  DOCUMENT_ECONSENT_SEND_ECONSENT_BUTTON: MvnCodeFE;
  DOCUMENT_ECONSENT_SEND_ECONSENT_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_ECONSENT_SEND_ECONSENT_DIALOG_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_SEND_ECONSENT_DIALOG_DESCRIPTION: MvnCodeFE;
  DOCUMENT_ECONSENT_SEND_SUCC: MvnCodeFE;
  DOCUMENT_ECONSENT_SEND_PARTIAL_SUCC_SUFFIX: MvnCodeFE;
  DOCUMENT_ECONSENT_SEND_FAIL: MvnCodeFE;
  DOCUMENT_ECONSENT_AUDIT_VALUE_SIGNER_CREATED: MvnCodeFE;
  DOCUMENT_ECONSENT_AUDIT_VALUE_SIGNER_DELETED: MvnCodeFE;
  DOCUMENT_ECONSENT_AUDIT_VALUE_SIGN_REQUESTED: MvnCodeFE;
  DOCUMENT_ECONSENT_DELIVERY_OPTION: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_OPTION_EMAIL: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_OPTION_MOBILE: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_SMS_PREFIX_TITLE: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_SMS_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_SCHEDULE_TITLE: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_SCHEDULE_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_DATETIME_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_EDIT_SCHEDULE_DIALOG_HEADER: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_ORGANIZATION_TITLE: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_ORGANIZATION_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_EMAIL_IMAGE_TITLE: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_EMAIL_IMAGE_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_SMS_CONTENT_TITLE: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_SMS_CONTENT_COMMON: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_SMS_CONTENT_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_SMS_CONTENT_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_SCHEDULE_SEND_SUCC: MvnCodeFE;
  DOCUMENT_SEND_SCHEDULED_ECONSENT_DELAY_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SEND_SCHEDULED_ECONSENT_PAST_TIME_SETTING: MvnCodeFE;
  DOCUMENT_SEND_SCHEDULED_ECONSENT_INNER_FIVE_MINUTE_SETTING: MvnCodeFE;
  DOCUMENT_SEND_CANCEL_SCHEDULED_ECONSENT_DIALOG_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SEND_CANCEL_SCHEDULED_ECONSENT_SUCCESS: MvnCodeFE;
  DOCUMENT_SEND_EDIT_SCHEDULED_ECONSENT_SUCCESS: MvnCodeFE;
  DOCUMENT_SEND_SCHEDULED_ECONSENT_SUBSCRIPTION_EXPIRED_DESC: MvnCodeFE;
  DOCUMENT_SEND_SCHEDULED_ECONSENT_MOVE_TO_SUBSCRIPTION_PAGE: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_TITLE_SUFFIX_KO: MvnCodeFE;
  DOCUMENT_SEND_ECONSENT_TITLE_SUFFIX_EN: MvnCodeFE;
  DOCUMENT_ECONSENT_REQUEST_DOWNLOAD_DOCUMENT_SUCC: MvnCodeFE;
  DOCUMENT_ECONSENT_REQUEST_DOWNLOAD_DOCUMENT_FAIL: MvnCodeFE;
  DOCUMENT_ECONSENT_DONOR: MvnCodeFE;
  DOCUMENT_ECONSENT_AGENT: MvnCodeFE;
  DOCUMENT_ECONSENT_AGENT_ACTIVE: MvnCodeFE;
  DOCUMENT_ECONSENT_AGENT_SIGN_SIGNATURE: MvnCodeFE;
  DOCUMENT_ECONSENT_TEXT_INPUT_FIELD_TITLE: MvnCodeFE;
  DOCUMENT_ECONSENT_TEXT_INPUT_FIELD_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_TEXT_INPUT_FIELD_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_TEXT_INPUT_FIELD_HELPER_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_TEXT_FREE_FIELD_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_TEXT_DATE_FIELD_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_SINGLE_SELECT_FIELD_TITLE: MvnCodeFE;
  DOCUMENT_ECONSENT_DROPDOWN_FIELD_TITLE: MvnCodeFE;
  DOCUMENT_ECONSENT_DROPDOWN_FILED_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_DROPDOWN_FIELD_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_DROPDOWN_FIELD_HELPER_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_DROPDOWN_MISSING_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_DROPDOWN_MISSING_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_DROPDOWN_OPTION_ITEM_MAX_COUNT: MvnCodeFE;
  DOCUMENT_ECONSENT_ADDRESS_FIELD_TITLE: MvnCodeFE;
  DOCUMENT_ECONSENT_ADD_ITEM_GROUP: MvnCodeFE;
  DOCUMENT_ECONSENT_SELECT_TEXT_FIELD_OPTION_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_SELECT_TEXT_FIELD_OPTION_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_CONSENT: MvnCodeFE;
  DOCUMENT_ECONSENT_CONSENT_ITEM: MvnCodeFE;
  DOCUMENT_ECONSENT_ADD_CONSENT_ITEM: MvnCodeFE;
  DOCUMENT_ECONSENT_RESPONSIVE_ITEM_ALT_TEXT_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_SELECT_DATE_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_DATE: MvnCodeFE;
  DOCUMENT_ECONSENT_SELECT_DATE_FORMAT_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_DATE_MISSING_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_DATE_MISSING_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_ADDRESS_FIELD_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_ADDRESS_FIELD_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_ADDRESS_MISSING_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_ADDRESS_MISSING_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_FOLLOW_WRITING_FIELD_TITLE: MvnCodeFE;
  DOCUMENT_ECONSENT_FOLLOW_WRITING_FIELD_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_FOLLOW_WRITING_FIELD_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_FOLLOW_WRITING_FIELD_MISSING: MvnCodeFE;
  DOCUMENT_ECONSENT_FOLLOW_WRITING_FIELD_FAILED_IDENTIFY_SIGNATURE: MvnCodeFE;
  DOCUMENT_ECONSENT_TEMPLATE: MvnCodeFE;
  DOCUMENT_ECONSENT_TEMPLATE_BUTTON: MvnCodeFE;
  DOCUMENT_ECONSENT_TEMPLATE_DIALOG_TITLE: MvnCodeFE;
  DOCUMENT_ECONSENT_TEMPLATE_DIALOG_DESCRIPTION: MvnCodeFE;
  DOCUMENT_ECONSENT_TEMPLATE_MISC_BUTTON: MvnCodeFE;
  DOCUMENT_ECONSENT_INVESTOR_AUTO_FILL_CHECKBOX: MvnCodeFE;
  DOCUMENT_ECONSENT_INVALID_TEMPLATE: MvnCodeFE;
  DOCUMENT_ECONSENT_STUDY_CREATED: MvnCodeFE;
  DOCUMENT_NO_SUBJECT_TEMPLATE: MvnCodeFE;
  DOCUMENT_ECONSENT_FILED_TO_FILL_BUTTON: MvnCodeFE;
  DOCUMENT_ECONSENT_COMPLETE_BUTTON: MvnCodeFE;
  DOCUMENT_ECONSENT_CANCEL_BULK_SUCC: MvnCodeFE;
  DOCUMENT_SIGN_EMAIL_VALIDATION_INVALID: MvnCodeFE;
  DOCUMENT_SIGN_EMAIL_VERIFICATION_CODE_INVALID: MvnCodeFE;
  DOCUMENT_SIGN_SIGNATURE_ANIMATION_DESC: MvnCodeFE;
  DOCUMENT_SIGN_SIGNATURE_PAD_DESC: MvnCodeFE;
  DOCUMENT_SIGN_DROPDOWN_MARKER_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_SIGNEE_NAME_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_SIGNEE_EMAIL_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_SIGNEE_JOB_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_SIGNEE_COMPANY_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_EMAIL_IMAGE_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SIGN_TITLE_INPUT_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_TITLE_INPUT_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_COMPLETE_BUTTON: MvnCodeFE;
  DOCUMENT_ECONSENT_SUBJECT_NAME_INPUT_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_SUBJECT_NAME_INPUT_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_SUBJECT_EMAIL_INPUT_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_SUBJECT_EMAIL_INPUT_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_SUBJECT_PHONE_INPUT_LABEL: MvnCodeFE;
  DOCUMENT_ECONSENT_SUBJECT_PHONE_INPUT_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_ECONSENT_SUBJECT_PHONE_INPUT_INVALID_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SIGN_RETURN_LIST_CONFIRM_TITLE: MvnCodeFE;
  DOCUMENT_SIGN_RETURN_LIST_CONFIRM_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SIGN_CLOSE_FIELD_SETTING_TITLE: MvnCodeFE;
  DOCUMENT_SIGN_CLOSE_FIELD_SETTING_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SIGN_REFERRER_SEGMENT_TITLE: MvnCodeFE;
  DOCUMENT_SIGN_SIGNER_SEGMENT_TITLE: MvnCodeFE;
  DOCUMENT_SIGN_REFERRER_NOT_EXISTS_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SIGN_REFERRER_SECTION_TITLE: MvnCodeFE;
  DOCUMENT_SIGN_REFERRER_ADD_BUTTON: MvnCodeFE;
  DOCUMENT_SIGN_REFERRER_NAME_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_REFERRER_EMAIL_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_REFERRER_COMPANY_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_REFERRER_JOB_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_REFERRER_NAME_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_REFERRER_EMAIL_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_REFERRER_COMPANY_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_REFERRER_JOB_PLACEHOLDER: MvnCodeFE;
  DOCUMENT_SIGN_REFERRER_INPUT_LENGTH_EXCEED_WARN_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SIGN_REFERRER_INPUT_REQUIRED_WARN_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SIGN_NAME_SETTING_DIALOG_TITLE: MvnCodeFE;
  DOCUMENT_SIGN_NAME_SETTING_DIALOG_INITIAL_TITLE: MvnCodeFE;
  DOCUMENT_SIGN_NAME_SETTING_DIALOG_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SIGN_TITLE_MAX_LENGTH_EXCEED: MvnCodeFE;
  DOCUMENT_SIGN_REQUEST_REASON_MAX_LENGTH_EXCEED: MvnCodeFE;
  DOCUMENT_SIGN_NAME_SETTING_DIALOG_TITLE_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_NAME_SETTING_DIALOG_TITLE_PLACEHOLDER: MvnCodeFE;
  FORM_INVALID: MvnCodeFE;
  FORM_REQUIRED: MvnCodeFE;
  FORM_EMAIL_CONTAIN_KOREAN: MvnCodeFE;
  DOCUMENT_SIGN_SUMMARIZE_DIALOG_TITLE: MvnCodeFE;
  DOCUMENT_SIGN_SUMMARIZE_DIALOG_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SIGN_SUMMARIZE_DIALOG_VERIFICATION_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_SUMMARIZE_DIALOG_EMAIL_VERIFICATION: MvnCodeFE;
  DOCUMENT_SIGN_SUMMARIZE_DIALOG_IDENTITY_VERIFICATION: MvnCodeFE;
  DOCUMENT_SIGN_SUMMARIZE_DIALOG_NONE_VERIFICATION: MvnCodeFE;
  DOCUMENT_SIGN_SUMMARIZE_DIALOG_REQUEST_INFO_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_FIELD_SETTING_RESET_BUTTON: MvnCodeFE;
  DOCUMENT_SIGN_STATUS_REFERRER_HIDE_TEXT_BUTTON: MvnCodeFE;
  DOCUMENT_SIGN_STATUS_REFERRER_LABEL: MvnCodeFE;
  DOCUMENT_SIGN_LIST_TABLE_TITLE_COLUMN: MvnCodeFE;
  DOCUMENT_SIGN_LIST_TABLE_UUID_COLUMN: MvnCodeFE;
  DOCUMENT_SIGN_LIST_TABLE_SIGNER_COLUMN: MvnCodeFE;
  DOCUMENT_SIGN_LIST_TABLE_REFERRER_COLUMN: MvnCodeFE;
  DOCUMENT_SIGN_LIST_TABLE_SIGN_STATUS_COLUMN: MvnCodeFE;
  DOCUMENT_SIGN_LIST_TABLE_UPDATE_AT_COLUMN: MvnCodeFE;
  DOCUMENT_SIGN_ADDITIONAL_MESSAGE_DESCRIPTION: MvnCodeFE;
  DOCUMENT_SIGN_DUPLICATE_EMAIL_WARN: MvnCodeFE;
} = {
  DOCUMENT_SIGN_COMMON_DECLINE_NOUN: {
    ko: "거절",
    en: "Decline",
  },
  DOCUMENT_CREATE_DIALOG_HEADER: {
    ko: "Add Document",
    en: "Add Document",
  },
  DOCUMENT_UPLOAD_FILE_DIALOG_HEADER: {
    ko: "파일 업로드",
    en: "Upload File",
  },
  DOCUMENT_UPLOAD_FILE_COUNT_LABEL: {
    ko: "파일 업로드 ({current}/{limit})",
    en: "Upload File ({current}/{limit})",
  },
  DOCUMENT_UPLOAD_PDF_FILE_DIALOG_HEADER: {
    ko: "PDF 파일 업로드",
    en: "Upload PDF File",
  },
  DOCUMENT_TITLE_LABEL: {
    ko: "Title",
    en: "Title",
  },
  DOCUMENT_VERSION_LABEL: {
    ko: "Version",
    en: "Version",
  },
  DOCUMENT_AVAILABLE_STORAGE: {
    ko: "* 저장공간 {size}{unit} 사용가능",
    en: "* Storage {size}{unit} Available",
  },
  /** @Deprecated */
  DOCUMENT_AVAILABLE_STORAGE_ARCHIVER: {
    ko: "{totalSize}{totalUnit} 중 {usageSize}{usageUnit} 사용",
    en: "{usageSize}{usageUnit} of {totalSize}{totalUnit} used",
  },
  DOCUMENT_ARCHIVER_STORAGE_TOTAL: {
    ko: "{size} {unit}",
    en: "{size} {unit}",
  },
  DOCUMENT_ARCHIVER_STORAGE_USAGE: {
    ko: "{size} {unit} 사용",
    en: "{size} {unit} Used",
  },
  DOCUMENT_FILE_LABEL: {
    ko: "File",
    en: "File",
  },
  DOCUMENT_FILE_PLACEHOLDER: {
    ko: "업로드할 파일을 선택해 주세요.",
    en: "Please choose a file to upload.",
  },
  DOCUMENT_FILE_LIMIT_SIZE_DESCRIPTION: {
    ko: "{type} 형식만 가능하며, 최대 {num}MB까지 업로드할 수 있습니다.",
    en: "Only {type} format up to {num}MB",
  },
  DOCUMENT_FILE_DESCRIPTION: {
    ko: "최대 {num}MB의 {type}파일을 업로드할 수 있습니다.",
    en: "{type} files up to {num}MB",
  },
  DOCUMENT_ADDITIONAL_MESSAGE_DESCRIPTION: {
    ko: "추가 메시지 입력",
    en: "Enter additional message",
  },
  DOCUMENT_FILE_TYPE_PLACEHOLDER: {
    ko: "업로드할 {type} 파일을 선택해 주세요.",
    en: "Please choose a {type} file to upload.",
  },
  DOCUMENT_FILE_SUCC: {
    ko: "파일 업로드에 성공했습니다.",
    en: "You have uploaded a file successfully.",
  },
  DOCUMENT_FILE_FAIL: {
    ko: "파일 업로드에 실패했습니다. ({message})",
    en: "Failed to upload a file. ({message})",
  },
  DOCUMENT_FILE_NOT_ALLOWED: {
    ko: "{type} 확장자의 파일만 업로드 할 수 있습니다.",
    en: "Only {type} files are allowed.",
  },
  DOCUMENT_FILE_EXCEEDS_MAX_SIZE: {
    ko: "파일이 {limit}MB를 초과합니다.",
    en: "The file exceeds {limit}MB.",
  },
  DOCUMENT_FILE_UPLOAD_ZERO_BYTES: {
    ko: "첨부하신 파일의 크기를 확인해주세요.",
    en: "Please check the size of the attached file.",
  },
  DOCUMENT_FILE_INVALID_EXTENSION: {
    ko: "파일 타입이 유효하지 않습니다 [{ext}]",
    en: "Invalid file type [{ext}]",
  },
  DOCUMENT_FILE_PDF_CONVERTING_TITLE: {
    ko: "로딩 중입니다. 잠시만 기다려주세요.",
    en: "Loading. Please wait a moment.",
  },
  DOCUMENT_FILE_PDF_CONVERTING_FAIL_TITLE: {
    ko: "PDF 변환에 실패했습니다.",
    en: "Failed to convert to PDF.",
  },
  DOCUMENT_FILE_PDF_CONVERTING_FAIL_DESC: {
    ko: "아래 재시도 버튼으로 다시 시도해주세요.",
    en: "Please retry by clicking button below.",
  },
  DOCUMENT_FILE_PDF_RETRY_CONVERT_LABEL: {
    ko: "PDF 변환 재시도",
    en: "Retry PDF Conversion",
  },
  DOCUMENT_FILE_UPLOAD_DND_HELPER_DESCRIPTION: {
    ko: "파일을 여기에 드래그 & 드랍 하세요",
    en: "Drag & Drop files here to upload",
  },
  DOCUMENT_FILE_MAX_COUNT_HELPER_TEXT: {
    ko: "최대 {count}개까지 업로드 가능합니다.",
    en: "You can upload up to {count} files.",
  },
  DOCUMENT_FILE_MULTIPLE_UPLOAD_NAME_PLACEHOLDER: {
    ko: "각 파일의 이름으로 업로드됩니다.",
    en: "Files will be uploaded using their original filenames.",
  },
  DOCUMENT_FILE_UPLOAD_EXTENSION_HELPER_TEXT: {
    ko: "{ext} 파일만 업로드 가능합니다.",
    en: "Only {ext} file is allowed.",
  },
  DOCUMENT_FILE_UPLOAD_SIZE_HELPER_TEXT: {
    ko: "각 파일 최대 {max}MB",
    en: "Each file up to {max}MB",
  },
  DOCUMENT_FILE_UPLOAD_RESULT_SUMMARY_TITLE: {
    ko: "업로드 결과 {total}개 중 {failCount}개 실패.",
    en: "Upload Result {total} files, {failCount} files failed.",
  },
  DOCUMENT_FILE_UPLOAD_FAIL_REASON_INVALID_EXTENSION: {
    ko: "유효하지 않은 확장자 {count}개",
    en: "Invalid extension {count} files",
  },
  DOCUMENT_FILE_UPLOAD_FAIL_REASON_PASSWORD_PROTECTED: {
    ko: "암호화된 파일 {count}개",
    en: "Password protected files {count} files",
  },
  DOCUMENT_FILE_UPLOAD_FAIL_REASON_EXCEEDS_MAX_SIZE: {
    ko: "최대 크기 초과 {count}개",
    en: "Exceeds max size {count} files",
  },
  DOCUMENT_FILE_TABLE_EMPTY_DND_DESCRIPTION: {
    ko: "드래그 & 드랍 또는 파일 업로드 버튼울 눌러주세요.",
    en: "Please drag and drop or press the file upload button.",
  },
  PDF_RETRY_CONVERT_REQUEST_SUCCESS_TOAST: {
    ko: "PDF 변환 재시도 요청에 성공했습니다.",
    en: "You have requested to retry the PDF conversion successfully.",
  },
  PDF_RETRY_CONVERT_REQUEST_FAIL_TOAST: {
    ko: "PDF 변환 재시도 요청에 실패했습니다. ({message})",
    en: "Failed to request to retry the PDF conversion. ({message})",
  },
  DOCUMENT_CREATE_SUCC: {
    ko: "문서 생성에 성공했습니다.",
    en: "You have added a document successfully.",
  },
  DOCUMENT_CREATE_FAIL: {
    ko: "문서 생성에 실패했습니다. ({message})",
    en: "Failed to add a document. ({message})",
  },
  DOCUMENT_DOWNLOAD_SUCC: {
    ko: "문서 다운로드가 시작되었습니다.",
    en: "You have started to download a document successfully.",
  },
  DOCUMENT_DOWNLOAD_FAIL: {
    ko: "문서 다운로드에 실패했습니다. ({message})",
    en: "Failed to download a document. ({message})",
  },
  DOCUMENT_ESIGN_HEADER: {
    ko: "전자서명 요청하기",
    en: "Request E-Sign",
  },
  DOCUMENT_ESIGN_CREATE_HEADER: {
    ko: "전자서명 파일 생성하기",
    en: "Create E-Sign File",
  },
  DOCUMENT_ESIGN_CREATE_DESCRIPTION: {
    ko: "생성된 전자서명 문서에 대해서 API 방식으로 서명 요청을 진행할 수 있습니다.",
    en: "E-Sign request can be sent via API call.",
  },
  DOCUMENT_ESIGN_SIGNATURE_HEADER: {
    ko: "전자서명 진행하기",
    en: "Proceed to E-Sign",
  },
  DOCUMENT_ESIGN_SIGNATURE_HEADER_SIGNED: {
    ko: "전자서명 서명완료",
    en: "Completed to E-Sign",
  },
  DOCUMENT_ESIGN_SIGNATURE_HEADER_CANCELED: {
    ko: "전자서명 취소됨",
    en: "Canceled to E-Sign",
  },
  DOCUMENT_ESIGN_SIGNATURE_HEADER_DECLINED: {
    ko: "전자서명 거절됨",
    en: "Declined to E-Sign",
  },
  DOCUMENT_START_ESIGN_BUTTON: {
    ko: "전자서명 시작하기",
    en: "Start E-Sign",
  },
  DOCUMENT_REQUEST_ESIGN_BUTTON: {
    ko: "전자서명 요청하기",
    en: "Request E-Sign",
  },
  DOCUMENT_REQUEST_ESIGN_BUTTON_WITH_COUNT: {
    ko: "전자서명 요청하기 (잔여 {count}건)",
    en: "Request E-Sign ({count} Remains)",
  },
  DOCUMENT_REQUEST_ESIGN_BUTTON_WITH_COUNT_UNLIMITED: {
    ko: "전자서명 요청하기 (무제한)",
    en: "Request E-Sign (Unlimited)",
  },
  DOCUMENT_REQUEST_ESIGN_DESCRIPTION: {
    ko: "서명 요청 1건이 차감됩니다.",
    en: "1 E-Sign request will be used.",
  },
  DOCUMENT_CREATE_ESIGN_BUTTON: {
    ko: "전자서명 파일 생성하기",
    en: "Create E-Sign File",
  },
  DOCUMENT_CANCEL_ESIGN_BUTTON: {
    ko: "전자서명 취소하기",
    en: "Cancel E-Sign",
  },
  DOCUMENT_SIGN_ESIGN_BUTTON: {
    ko: "전자서명 진행하기",
    en: "Proceed to E-Sign",
  },
  DOCUMENT_SIGN_ESIGN_ENTER_BUTTON: {
    ko: "서명 입력하기",
    en: "Enter Signature",
  },
  DOCUMENT_SIGN_ESIGN_ENTER_NOTI: {
    ko: "서명 영역을 클릭하여 서명을 입력해 주세요.",
    en: "Please enter your signature by clicking on an e-sign area.",
  },
  DOCUMENT_SIGN_ESIGN_REASON_LABEL: {
    ko: "서명 사유",
    en: "Signing Reason",
  },
  DOCUMENT_SIGN_ESIGN_REASON_SELECT_PLACEHOLDER: {
    ko: "서명 사유를 선택해 주세요.",
    en: "Please select the signing reason",
  },
  DOCUMENT_SIGN_ESIGN_REASON_PLACEHOLDER: {
    ko: "서명 사유를 입력해 주세요.",
    en: "Please enter the signing reason",
  },
  DOCUMENT_SIGN_ESIGN_REASON_APPROVER: {
    ko: "문서를 승인합니다.",
    en: "I approve this document",
  },
  DOCUMENT_SIGN_ESIGN_REASON_REVIEWER: {
    ko: "문서를 검토하였습니다.",
    en: "I have reviewed this document",
  },
  DOCUMENT_SIGN_ESIGN_REASON_CONFIRM_WRITE: {
    ko: "문서를 작성하였습니다.",
    en: "I have written this document",
  },
  DOCUMENT_SIGN_ESIGN_REASON_OWNER: {
    ko: "이 문서의 소유자입니다.",
    en: "I am the owner of this document",
  },
  DOCUMENT_SIGN_ESIGN_REASON_OTHER: {
    ko: "기타 (직접 입력)",
    en: "Other (Direct Input)",
  },
  DOCUMENT_SIGN_ESIGN_EMAIL_VERIFICATION_LABEL: {
    ko: "이메일 인증코드",
    en: "Email Verification Code",
  },
  DOCUMENT_SIGN_ESIGN_EMAIL_VERIFICATION_PLACEHOLDER: {
    ko: "Email({email})로 전송된 인증코드를 입력해 주세요.",
    en: "Please enter the verification code sent via email({email}).",
  },
  DOCUMENT_SIGN_ESIGN_TABLE_EMPTY_TITLE: {
    ko: "서명을 요청한 문서가 없습니다.",
    en: "No document has requested to sign.",
  },
  DOCUMENT_SIGN_DECLINE_BUTTON: {
    ko: "전자서명 거절하기",
    en: "Decline to E-Sign",
  },
  DOCUMENT_SIGN_CANCEL_BUTTON: {
    ko: "전자서명 요청 취소하기",
    en: "Cancel to E-Sign Request",
  },
  DOCUMENT_SIGN_DOWNLOAD_BUTTON: {
    ko: "서명 완료 문서 다운로드",
    en: "Download E-Signed Document",
  },
  DOCUMENT_SIGN_DOWNLOAD_BUTTON_GENERATING: {
    ko: "서명 완료 문서 다운로드 (생성중 ..)",
    en: "Download E-Signed Doc. (Generating ..)",
  },
  DOCUMENT_SIGN_DOWNLOAD_REPORT_BUTTON: {
    ko: "감사 추적 보고서 다운로드",
    en: "Download Audit Trail Report",
  },
  DOCUMENT_SIGN_DOWNLOAD_MERGED_BUTTON: {
    ko: "서명 완료 문서 + 감사 추적 보고서 다운로드",
    en: "Download E-Signed Document + Audit Trail Report",
  },
  DOCUMENT_SIGN_SEE_DOCUMENT_BUTTON: {
    ko: "서명 문서 보기",
    en: "See Document",
  },
  DOCUMENT_SIGN_SIGNATURE_ENTER: {
    ko: "서명 입력",
    en: "Draw signature",
  },
  DOCUMENT_SIGN_STAMP_ENTER: {
    ko: "도장 입력",
    en: "Upload stamp image",
  },
  DOCUMENT_SIGN_STAMP_DESCRIPTION: {
    ko: "실제 도장을 찍은 사진을 업로드해 주세요.",
    en: "Upload an image of actual stamp.",
  },
  DOCUMENT_ADD_SIGNER_BUTTON: {
    ko: "서명자 추가 ({signerCount}/{maxSignerCount})",
    en: "Add Signee ({signerCount}/{maxSignerCount})",
  },
  DOCUMENT_NTH_SIGNER_LABEL: {
    ko: "서명자 {signerIndex}",
    en: "Signee {signerIndex}",
  },
  DOCUMENT_NTH_INVESTIGATOR_LABEL: {
    ko: "연구자",
    en: "Principal Investigator",
  },
  DOCUMENT_NTH_INVESTIGATOR_SHORT_LABEL: {
    ko: "연구자",
    en: "P.I",
  },
  DOCUMENT_SIGN_FIELD_SETTING_HEADER: {
    ko: "전자서명 설정",
    en: "E-Sign settings",
  },
  DOCUMENT_SIGN_REQ_FIELDS_FULFILL: {
    ko: "필수 항목을 모두 입력해 주세요.",
    en: "Please fulfill all required fields.",
  },
  DOCUMENT_SIGN_SIGNATURE_MISSING: {
    ko: "서명을 입력해 주세요.",
    en: "Please enter your signature.",
  },
  DOCUMENT_SIGN_ZEROBYTES_IMAGE: {
    ko: "첨부하신 이미지 파일의 크기를 확인해주세요.",
    en: "Please check the size of the attached image file.",
  },
  DOCUMENT_SIGN_AGREE_AND_PROCEED: {
    ko: "동의 및 서명 완료",
    en: "Agree & Complete Sign",
  },
  DOCUMENT_SIGN_DIALOG_HEADER: {
    ko: "전자서명 이용약관",
    en: "E-Sign Agreement",
  },
  DOCUMENT_SIGN_DECLINE_DIALOG_HEADER: {
    ko: "전자서명 거절하기",
    en: "Decline to E-Sign",
  },
  DOCUMENT_SIGN_CANCEL_DIALOG_HEADER: {
    ko: "전자서명 요청 취소하기",
    en: "Cancel to E-Sign Request",
  },
  DOCUMENT_SIGN_DIALOG_AGREEMENT_EFFECT: {
    ko: "전자서명을 진행하고, 전자문서의 법적 효력에 대해 동의합니다.",
    en: "Proceed with the e-sign and consent to the legal effect of the e-document.",
  },
  DOCUMENT_SIGN_DIALOG_AGREEMENT_ORIGINAL: {
    ko: "전자서명이 완료된 후 전송되는 전자문서를 원본으로 인정합니다.",
    en: "I admit the e-document that will be sent after the e-sign completed as the original.",
  },
  DOCUMENT_SIGN_DIALOG_AGREEMENT_ETC_PREFIX: {
    ko: "기타 자세한 내용은 ",
    en: "I consent to other details by ",
  },
  DOCUMENT_SIGN_DIALOG_AGREEMENT_ETC_LINK: {
    ko: "전자서명 이용약관",
    en: "the terms and conditions of e-sign",
  },
  DOCUMENT_SIGN_DIALOG_AGREEMENT_ETC_SUFFIX: {
    ko: "에 따라 동의합니다.",
    en: ".",
  },
  DOCUMENT_SIGN_DIALOG_DECLINE_CONFIRM: {
    ko: "문서 서명 요청을 거절하시겠습니까?",
    en: "Are you sure to decline the document signing request?",
  },
  DOCUMENT_SIGN_DIALOG_DECLINE_WARNING: {
    ko: "전자서명 거절은 취소할 수 없습니다.",
    en: "The decline to request of e-sign cannot be reverted.",
  },
  DOCUMENT_SIGN_DIALOG_CANCEL_CONFIRM: {
    ko: "문서 서명 요청을 취소하시겠습니까?",
    en: "Are you sure to cancel the document signing request?",
  },
  DOCUMENT_SIGN_DIALOG_CANCEL_BULK_DESC: {
    ko: "서명 대기 또는 서명 진행 중인 요청 건만 취소 가능합니다.",
    en: "Only requests that are pending signature or in the process of being signed can be cancelled.",
  },
  DOCUMENT_SIGN_DIALOG_CANCEL_WARNING: {
    ko: "전자서명 요청 취소는 되돌릴 수 없습니다.",
    en: "The cancel to request of e-sign cannot be reverted.",
  },
  DOCUMENT_SIGN_CANCEL: {
    ko: "취소",
    en: "Cancel",
  },
  DOCUMENT_SIGN_MERGING: {
    ko: "진행 중..",
    en: "Merging ..",
  },
  DOCUMENT_SIGN_REQUEST_NOUN: {
    ko: "요청",
    en: "Request",
  },
  DOCUMENT_SIGN_REQUEST_SUCC: {
    ko: "문서 서명 요청에 성공했습니다.",
    en: "Document signing request has been created successfully.",
  },
  DOCUMENT_SIGN_REQUEST_FAIL: {
    ko: "문서 서명 요청에 실패했습니다. ({message})",
    en: "The document sign request failed. ({message})",
  },
  DOCUMENT_SIGN_CREATE_SUCC: {
    ko: "전자서명 파일 생성에 성공했습니다.",
    en: "You have created an e-sign file successfully.",
  },
  DOCUMENT_SIGN_CREATE_FAIL: {
    ko: "전자서명 파일 생성에 실패했습니다. ({message})",
    en: "Failed to create an e-sign file. ({message})",
  },
  DOCUMENT_SIGN_ESIGN_SUCC: {
    ko: "문서 서명에 성공했습니다.",
    en: "Document has been signed successfully.",
  },
  DOCUMENT_SIGN_ESIGN_FAIL: {
    ko: "문서 서명에 실패했습니다. ({message})",
    en: "The document signing request failed. ({message})",
  },
  DOCUMENT_SIGN_DECLINE_SUCC: {
    ko: "문서 서명 요청을 거절하였습니다.",
    en: "The document signing request was declined.",
  },
  DOCUMENT_SIGN_DECLINE_FAIL: {
    ko: "문서 서명 거절에 실패했습니다. ({message})",
    en: "Decline to document signing request failed. ({message})",
  },
  DOCUMENT_SIGN_CANCEL_SUCC: {
    ko: "문서 서명 요청을 취소하였습니다.",
    en: "The document signing request was canceled.",
  },
  DOCUMENT_SIGN_CANCEL_FAIL: {
    ko: "문서 서명 요청 취소에 실패했습니다. ({message})",
    en: "Cancel to document signing request failed. ({message})",
  },
  DOCUMENT_SIGN_NAME: {
    ko: "이름",
    en: "Name",
  },
  DOCUMENT_SIGN_NAME_PLACEHOLDER: {
    ko: "이름 입력",
    en: "Enter name",
  },
  DOCUMENT_SIGN_EMAIL: {
    ko: "이메일",
    en: "Email",
  },
  DOCUMENT_SIGN_EMAIL_PLACEHOLDER: {
    ko: "이메일 입력",
    en: "Enter email",
  },
  DOCUMENT_SIGN_COMPANY: {
    ko: "소속(회사)",
    en: "Company",
  },
  DOCUMENT_SIGN_COMPANY_PLACEHOLDER: {
    ko: "회사 입력",
    en: "Enter company name",
  },
  DOCUMENT_SIGN_TITLE: {
    ko: "직위/직책",
    en: "Title",
  },
  DOCUMENT_SIGN_TITLE_PLACEHOLDER: {
    ko: "직위/직책 입력",
    en: "Enter job title",
  },
  DOCUMENT_SIGN_SIGNATURE: {
    ko: "서명",
    en: "Signature",
  },
  DOCUMENT_SIGN_PHONE: {
    ko: "전화번호",
    en: "Phone",
  },
  DOCUMENT_SIGN_ORGANIZATION_RESEARCH_INFO_TITLE: {
    ko: "연구 기관 정보",
    en: "Research Organization Information",
  },
  DOCUMENT_SIGN_DATE: {
    ko: "서명일",
    en: "Date",
  },
  DOCUMENT_SIGN_LABEL: {
    ko: "라벨",
    en: "Label",
  },
  DOCUMENT_SIGN_PRO_PLAN: {
    ko: "Pro Plan",
    en: "Pro Plan",
  },
  DOCUMENT_SIGN_OPT_GXP_COMPLY: {
    ko: "GxP(21 CFR Part 11) 규정 준수",
    en: "Comply with GxP(21 CFR Part 11)",
  },
  DOCUMENT_SIGN_OPT_ADVANCED_MODE: {
    ko: "Advanced Mode",
    en: "Advanced Mode",
  },
  DOCUMENT_SIGN_OPT_NO_REQUIRE_VERIFICATION: {
    ko: "문서 열람 시 인증 불필요",
    en: "Verification Not Required",
  },
  DOCUMENT_SIGN_OPT_REQUIRE_EMAIL_VERIFICATION: {
    ko: "문서 열람 시 이메일 인증 필요",
    en: "Require email address verification to open",
  },
  DOCUMENT_SIGN_OPT_REQUIRE_PERSONAL_IDENTIFICATION: {
    ko: "문서 열람 시 본인 인증 필요",
    en: "Require personal identification to open",
  },
  DOCUMENT_SIGN_OPT_ASSIGN_PROGRAMMATICALLY: {
    ko: "API 기반 서명자 지정",
    en: "Assign Signee programmatically",
  },
  DOCUMENT_SIGN_OPT_ESIGN_AUTOMATICALLY: {
    ko: "자동(시스템) 전자서명",
    en: "E-Sign automatically",
  },
  DOCUMENT_SIGN_OPT_SILENT_MODE: {
    ko: "Silent Mode (알림 메일 전송 생략)",
    en: "Silent mode (Notifications will not be sent)",
  },
  DOCUMENT_SIGN_OPT_RESPONSIVE_ITEM_INDEX: {
    ko: "응답 항목",
    en: "Responsive Item",
  },
  DOCUMENT_SIGN_OPT_RESPONSIVE_ITEM_GROUP: {
    ko: "응답 항목 그룹",
    en: "Responsive Item Group",
  },
  DOCUMENT_SIGN_OPT_ADD_RESPONSIVE_ITEM: {
    ko: "응답 항목 추가",
    en: "Add Responsive Item",
  },
  DOCUMENT_SIGN_OPT_ADD_LABEL: {
    ko: "라벨 추가",
    en: "Add Label",
  },
  DOCUMENT_SIGN_OPT_RESPONSIVE_ITEM_MISSING_LABEL: {
    ko: "미입력 시 안내 문구",
    en: "Alert Message for Missing Answer",
  },
  DOCUMENT_SIGN_OPT_RESPONSIVE_ITEM_MISSING_PLACEHOLDER: {
    ko: "표시할 문구를 입력해주세요.",
    en: "Enter a message for missing answer",
  },
  DOCUMENT_SIGN_OPT_RESPONSIVE_ITEM_INVALID_LABEL: {
    ko: "오입력 시 안내 문구",
    en: "Alert Message for Incorrect Answer",
  },
  DOCUMENT_SIGN_OPT_RESPONSIVE_ITEM_INVALID_PLACEHOLDER: {
    ko: "표시할 문구를 입력해주세요.",
    en: "Enter a message for incorrect answer",
  },
  DOCUMENT_SIGN_OPT_STAMP_API_URL_LABEL: {
    ko: "API URL",
    en: "API URL",
  },
  DOCUMENT_SIGN_OPT_STAMP_API_URL_PLACEHOLDER: {
    ko: "Enter URL (e.g. https://api.com/stamp)",
    en: "Enter URL (e.g. https://api.com/stamp)",
  },
  DOCUMENT_SIGN_OPT_STAMP_API_TIMING_LABEL: {
    ko: "호출 시점",
    en: "Timing",
  },
  DOCUMENT_SIGN_OPT_STAMP_API_TIMING_PLACEHOLDER: {
    ko: "API 호출 시점을 선택해 주세요.",
    en: "Select the API call timing",
  },
  DOCUMENT_SIGN_OPT_ADD_STAMP_API: {
    ko: "Stamp API 연동",
    en: "Stamp API integration",
  },
  DOCUMENT_SIGN_HISTORY_REASON: {
    ko: "사유: ",
    en: "Reason: ",
  },
  DOCUMENT_SIGN_HISTORY_SIGN_START_PREFIX: {
    ko: "",
    en: "",
  },
  DOCUMENT_SIGN_HISTORY_SIGN_START_SUFFIX: {
    ko: "님이 문서 서명 요청을 시작하였습니다.",
    en: " has started a document signing request.",
  },
  DOCUMENT_SIGN_HISTORY_DELIVERED_PREFIX: {
    ko: "",
    en: "Signing document has been delivered to ",
  },
  DOCUMENT_SIGN_HISTORY_DELIVERED_SUFFIX: {
    ko: "님에게 서명할 문서를 전송하였습니다.",
    en: "",
  },
  DOCUMENT_SIGN_HISTORY_REMIND_PREFIX: {
    ko: "",
    en: "Signing document has been resent to ",
  },
  DOCUMENT_SIGN_HISTORY_REMIND_SUFFIX: {
    ko: "님에게 서명할 문서를 재전송하였습니다.",
    en: "",
  },
  DOCUMENT_SIGN_HISTORY_OPENED_PREFIX: {
    ko: "",
    en: "",
  },
  DOCUMENT_SIGN_HISTORY_REFERRER_OPENED_PREFIX: {
    ko: "",
    en: "",
  },
  DOCUMENT_SIGN_HISTORY_REFERRER_OPENED_SUFFIX: {
    ko: "님이 문서를 열람하였습니다.",
    en: " has opened the document.",
  },
  DOCUMENT_SIGN_HISTORY_OPENED_SUFFIX: {
    ko: "님이 서명할 문서를 열람하였습니다.",
    en: " has opened the document to sign.",
  },
  DOCUMENT_SIGN_HISTORY_SIGNED_PREFIX: {
    ko: "",
    en: "",
  },
  DOCUMENT_SIGN_HISTORY_SIGNED_SUFFIX: {
    ko: "님이 문서에 서명을 완료하였습니다.",
    en: " has completed signing the document.",
  },
  DOCUMENT_SIGN_HISTORY_DECLINED_PREFIX: {
    ko: "",
    en: "",
  },
  DOCUMENT_SIGN_HISTORY_DECLINED_SUFFIX: {
    ko: "님이 문서에 서명을 거절하였습니다.",
    en: " has declined signing the document.",
  },
  DOCUMENT_SIGN_HISTORY_CANCELED_PREFIX: {
    ko: "",
    en: "",
  },
  DOCUMENT_SIGN_HISTORY_CANCELED_SUFFIX: {
    ko: "님이 문서 서명 요청을 취소하였습니다.",
    en: " has canceled signing request to the document.",
  },
  DOCUMENT_SIGN_HISTORY_CANCEL_REASON_PREFIX: {
    ko: "(사유: ",
    en: "(Reason: ",
  },
  DOCUMENT_SIGN_HISTORY_CANCEL_REASON_SUFFIX: {
    ko: ")",
    en: ")",
  },
  DOCUMENT_SIGN_HISTORY_SIGN_EXPIRED_PREFIX: {
    ko: "문서 서명 요청이 만료되었습니다.",
    en: "The e-sign request to document has expired.",
  },
  DOCUMENT_SIGN_HISTORY_SIGN_EXPIRED_SUFFIX: {
    ko: "",
    en: "",
  },
  DOCUMENT_SIGN_HISTORY_SIGN_END_PREFIX: {
    ko: "문서의 서명이 완료되었습니다.",
    en: "The document signing has completed.",
  },
  DOCUMENT_SIGN_HISTORY_SIGN_END_SUFFIX: {
    ko: "",
    en: "",
  },
  DOCUMENT_SIGN_HISTORY_SIGN_DECLINE_PREFIX: {
    ko: "문서 서명 요청 거절이 완료되었습니다.",
    en: "The decline request to document signing has completed.",
  },
  DOCUMENT_SIGN_HISTORY_SIGN_DECLINE_SUFFIX: {
    ko: "",
    en: "",
  },
  DOCUMENT_SIGN_HISTORY_SIGN_CANCEL_PREFIX: {
    ko: "문서 서명 요청 취소가 완료되었습니다.",
    en: "The cancel request to document signing has completed.",
  },
  DOCUMENT_SIGN_HISTORY_SIGN_CANCEL_SUFFIX: {
    ko: "",
    en: "",
  },
  DOCUMENT_SIGN_CERTIFICATE_DESC_DIGEST: {
    ko: "각 Action에 대한 정보를 포함하는 값을 의미합니다.",
    en: "Represents the value of each Action’s information",
  },
  DOCUMENT_SIGN_CERTIFICATE_DESC_DIGEST_HASH: {
    ko: "Digest 값을 SHA512 알고리즘으로 단방향 암호화한 값을 의미합니다.",
    en: "Represents the Digest value of one way encryption in SHA512 Algorithm",
  },
  DOCUMENT_SIGN_CERTIFICATE_DESC_HASH_CHAIN: {
    ko: "각 Digest Hash 값과 이전의 Hash Chain 값을 SHA1 알고리즘으로 단방향 암호화한 값을 의미합니다. 모든 Audit Trail은 서명 요청 시점부터 Chaining 되어 데이터의 위/변조를 원천 봉쇄합니다.",
    en: "Represents each Digest Hash value and previous Hash Chain value of one way encryption in SHA1 algorithm. Every audit trail are chained to prevent and block any bias or manipulation starting from e-sign request.",
  },
  DOCUMENT_SIGN_DIALOG_CANCEL_REASON: {
    ko: "취소사유",
    en: "Cancellation reason",
  },
  DOCUMENT_SIGN_DIALOG_CHANGE_DOC: {
    ko: "문서를 변경합니다.",
    en: "Change the document.",
  },
  DOCUMENT_SIGN_DIALOG_CHANGE_SIGNEE: {
    ko: "서명자 정보를 변경합니다.",
    en: "Change made to the signee's information.",
  },
  DOCUMENT_SIGN_DIALOG_DELETE_SIGNEE: {
    ko: "연구 대상자를 삭제했습니다.",
    en: "Delete the subject.",
  },
  DOCUMENT_SIGN_DIALOG_OTHER: {
    ko: "기타 (직접 입력)",
    en: "Other (Direct Input)",
  },
  DOCUMENT_SIGN_ECONSENT_STATUS_TITLE: {
    ko: "eConsent 상태",
    en: "eConsent Status",
  },
  DOCUMENT_SIGN_ECONSENT_BUTTON: {
    ko: "eConsent 진행하기",
    en: "Proceed to eConsent",
  },
  DOCUMENT_SIGN_FAILED_IDENTIFY_SIGNATURE: {
    ko: "서명을 식별할 수 없습니다. 더 크게 입력해 주세요.",
    en: "Failed to identify signature. Please enter signature larger.",
  },
  DOCUMENT_ECONSENT_SIGNATURE_HEADER: {
    ko: "eConsent 진행하기",
    en: "Proceed eConsent",
  },
  DOCUMENT_ECONSENT_SIGNATURE_HEADER_SIGNED: {
    ko: "eConsent 서명완료",
    en: "Completed eConsent",
  },
  DOCUMENT_ECONSENT_SIGNATURE_HEADER_CANCELED: {
    ko: "eConsent 취소됨",
    en: "Canceled eConsent",
  },
  DOCUMENT_ECONSENT_SIGNATURE_HEADER_DECLINED: {
    ko: "eConsent 거절됨",
    en: "Declined to eConsent",
  },
  DOCUMENT_SIGN_ECONSENT_REASON_APPROVER_SIGNER: {
    ko: "본 연구 참여에 동의합니다.",
    en: "I consent to the participation of this study.",
  },
  DOCUMENT_SIGN_ECONSENT_REASON_APPROVER_INVESTIGATOR: {
    ko: "연구 대상자가 충분한 이해 후 자발적으로 동의하였음을 확인했습니다.",
    en: "I confirm the subject has read and understood the study and has voluntarily consented to participation.",
  },
  DOCUMENT_ECONSENT_DECLINE_BUTTON: {
    ko: "전자 동의서 거절하기",
    en: "Decline eConsent",
  },
  DOCUMENT_ECONSENT_CANCEL_BUTTON: {
    ko: "eConsent 요청 취소하기",
    en: "Cancel to eConsent Request",
  },
  DOCUMENT_ECONSENT_DOWNLOAD_BUTTON: {
    ko: "전자 동의 완료 문서 다운로드",
    en: "Download E-Signed Document",
  },
  DOCUMENT_ECONSENT_DOWNLOAD_BUTTON_GENERATING: {
    ko: "전자 동의 완료 문서 다운로드 (생성중 ..)",
    en: "Download E-Signed Doc. (Generating ..)",
  },
  DOCUMENT_ECONSENT_DIALOG_HEADER: {
    ko: "전자동의 이용약관",
    en: "eConsent Agreement",
  },
  DOCUMENT_ECONSENT_DECLINE_DIALOG_HEADER: {
    ko: "전자동의 거절하기",
    en: "Decline eConsent",
  },
  DOCUMENT_ECONSENT_CANCEL_DIALOG_HEADER: {
    ko: "전자동의 요청 취소하기",
    en: "Cancel eConsent Request",
  },
  DOCUMENT_ECONSENT_DIALOG_AGREEMENT_EFFECT: {
    ko: "전자동의를 진행하고, 전자문서의 법적 효력에 대해 동의합니다.",
    en: "Proceed with the eConsent and consent to the legal effect of the e-document.",
  },
  DOCUMENT_ECONSENT_DIALOG_AGREEMENT_ORIGINAL: {
    ko: "전자동의가 완료된 후 전송되는 전자문서를 원본으로 인정합니다.",
    en: "I admit the e-document that will be sent after the eConsent completed as the original.",
  },
  DOCUMENT_ECONSENT_DIALOG_AGREEMENT_ETC_LINK: {
    ko: "전자동의 이용약관",
    en: "the terms and conditions of eConsent",
  },
  DOCUMENT_ECONSENT_DIALOG_DECLINE_WARNING: {
    ko: "전자동의 거절은 취소할 수 없습니다.",
    en: "The decline to request of eConsent cannot be reverted.",
  },
  DOCUMENT_ECONSENT_DIALOG_CANCEL_DESC: {
    ko: "{count} 전자동의 요청을 취소하시겠습니까?\n(서명 대기 또는 서명 진행중인 요청건만 취소 가능합니다.)",
    en: "Are you sure you want to cancel the eConsent signature request for {count} item(s)?\n(Only requests that are pending signature or in the process of being signed can be cancelled).",
  },
  DOCUMENT_ECONSENT_DIALOG_CANCEL_WARNING: {
    ko: "전자동의 요청 취소는 되돌릴 수 없습니다.",
    en: "The cancel to request of eConsent cannot be reverted.",
  },
  DOCUMENT_ECONSENT_LABEL: {
    ko: "옵션",
    en: "Option",
  },
  DOCUMENT_ECONSENT_REQ: {
    ko: "정답",
    en: "Correct",
  },
  DOCUMENT_ECONSENT_OPT_RESPONSIVE_ITEM_INDEX: {
    ko: "질문 항목",
    en: "Question Item",
  },
  DOCUMENT_ECONSENT_OPT_ADD_RESPONSIVE_ITEM_GROUP: {
    ko: "질문 추가",
    en: "Add Question",
  },
  DOCUMENT_ECONSENT_OPT_ADD_OPTION: {
    ko: "옵션 추가",
    en: "Add Option",
  },
  DOCUMENT_ECONSENT_CREATE_ICF_DIALOG_HEADER: {
    ko: "ICF 생성",
    en: "Create ICF",
  },
  DOCUMENT_ECONSENT_ADD_SUBJECTS_DIALOG_HEADER: {
    ko: "Add Multiple Subjects",
    en: "Add Multiple Subjects",
  },
  DOCUMENT_ECONSENT_ADD_SUBJECT_DIALOG_HEADER: {
    ko: "Add Single Subject",
    en: "Add Single Subject",
  },
  DOCUMENT_ECONSENT_SUBJECT_LIST_DIALOG_HEADER: {
    ko: "Subject List",
    en: "Subject List",
  },
  DOCUMENT_ECONSENT_DOWNLOAD_LIST_DIALOG_BUTTON: {
    ko: "Download List",
    en: "Download List",
  },
  DOCUMENT_EXCEL_DOWNLOAD_DESCRIPTION: {
    ko: "엑셀 템플릿을 다운로드 받아서 작성해 주세요.",
    en: "Please download and fill out the Excel template.",
  },
  DOCUMENT_ECONSENT_ADD_SUBJECT_LIMIT: {
    ko: "템플릿으로 최대 1,000명까지 한 번에 추가할 수 있습니다.",
    en: "You can add up to 1,000 subjects at once with template.",
  },
  DOCUMENT_ECONSENT_SUBJECTS_VALIDATE: {
    ko: "중복과 무효한 항목을 제외한 총 {count}명의 서명 대상자를 등록하시겠습니까?",
    en: "Are you sure to add {count} subjects excluding duplicates and invalids?",
  },
  DOCUMENT_ECONSENT_ADD_SUBJECTS_SUCC: {
    ko: "연구 대상자를 추가하였습니다.",
    en: "Subject has been added.",
  },
  DOCUMENT_ECONSENT_ADD_SUBJECTS_FAIL: {
    ko: "연구 대상자 등록에 실패했습니다.",
    en: "Failed to add subjects.",
  },
  DOCUMENT_ECONSENT_ADD_SUBJECT_FAIL: {
    ko: "연구 대상자 등록에 실패했습니다. ({message})",
    en: "Failed to add a subject. ({message})",
  },
  DOCUMENT_ECONSENT_CREATE_STUDY_NAME_MISSING: {
    ko: "스터디 이름을 입력해주세요.",
    en: "Please Enter Study Name.",
  },
  DOCUMENT_ECONSENT_CREATE_ICF_SECTION_HEADER: {
    ko: "ICF 생성하기",
    en: "Create ICF",
  },
  DOCUMENT_ECONSENT_CREATE_ICF_SECTION_BUTTON: {
    ko: "ICF 생성하기",
    en: "Create ICF",
  },
  DOCUMENT_ECONSENT_CREATE_ICF_SUCC: {
    ko: "ICF가 생성되었습니다.",
    en: "ICF has been created.",
  },
  DOCUMENT_ECONSENT_CREATE_ICF_FAIL: {
    ko: "문서 생성에 실패했습니다. ({message})",
    en: "Failed to add a document. ({message})",
  },
  DOCUMENT_ECONSENT_CREATE_ICF_NAME_MISSING: {
    ko: "ICF 이름을 입력해주세요.",
    en: "Please Enter ICF Name.",
  },
  DOCUMENT_ECONSENT_CREATE_ICF_VERSION_MISSING: {
    ko: "ICF 버전을 입력해주세요.",
    en: "Please Enter ICF Version.",
  },
  DOCUMENT_ECONSENT_SEND_ECONSENT_BUTTON: {
    ko: "전자 동의서 전송",
    en: "Send eConsent",
  },
  DOCUMENT_ECONSENT_SEND_ECONSENT_DIALOG_HEADER: {
    ko: "Send eConsent",
    en: "Send eConsent",
  },
  DOCUMENT_ECONSENT_SEND_ECONSENT_DIALOG_PLACEHOLDER: {
    ko: "ICF를 선택해 주세요.",
    en: "Please choose an ICF to send eConsent.",
  },
  DOCUMENT_ECONSENT_SEND_ECONSENT_DIALOG_DESCRIPTION: {
    ko: "{count}명의 대상자에게 전자 동의서를 전송하시겠습니까?",
    en: "Are you sure to send eConsent to {count} subjects?",
  },
  DOCUMENT_ECONSENT_SEND_SUCC: {
    ko: "eConsent가 전송되었습니다.",
    en: "eConsent has been sent.",
  },
  DOCUMENT_ECONSENT_SEND_PARTIAL_SUCC_SUFFIX: {
    ko: "(일부는 전송에 실패했습니다.)",
    en: "(Some eConsents have failed to send.)",
  },
  DOCUMENT_ECONSENT_SEND_FAIL: {
    ko: "전자 동의서 전송에 실패했습니다. ({message})",
    en: "You have failed to send eConsents. ({message})",
  },
  // NOTE: 다른 부분의 Audit에서도 지속적으로 Message가 필요하면 Audit파일로 분리가 좋을 것 같음
  DOCUMENT_ECONSENT_AUDIT_VALUE_SIGNER_CREATED: {
    ko: "{count}명 연구대상자 등록",
    en: "{count} subject(s) added",
  },
  DOCUMENT_ECONSENT_AUDIT_VALUE_SIGNER_DELETED: {
    ko: "{count}명 연구대상자 삭제",
    en: "{count} subject(s) deleted",
  },
  DOCUMENT_ECONSENT_AUDIT_VALUE_SIGN_REQUESTED: {
    ko: "{count}명에게 전자 동의 전송",
    en: "eConsent sended to {count} subject(s)",
  },
  DOCUMENT_ECONSENT_DELIVERY_OPTION: {
    ko: "eConsent 발송 옵션",
    en: "eConsent Delivery Options",
  },
  DOCUMENT_SEND_ECONSENT_OPTION_EMAIL: {
    ko: "이메일 전송",
    en: "Send via Email",
  },
  DOCUMENT_SEND_ECONSENT_OPTION_MOBILE: {
    ko: "문자 전송",
    en: "Send via SMS",
  },
  DOCUMENT_SEND_ECONSENT_SMS_PREFIX_TITLE: {
    ko: "문자 머릿말",
    en: "SMS prefix",
  },
  DOCUMENT_SEND_ECONSENT_SMS_DESCRIPTION: {
    ko: "eConsent가 문자로도 전송됩니다.",
    en: "eConsent can also be sent via SMS.",
  },
  DOCUMENT_SEND_ECONSENT_SCHEDULE_TITLE: {
    ko: "예약 발송",
    en: "Scheduled Send",
  },
  DOCUMENT_SEND_ECONSENT_SCHEDULE_DESCRIPTION: {
    ko: "eConsent가 예약 발송됩니다.",
    en: "The eConsent will be sent at the scheduled time.",
  },
  DOCUMENT_SEND_ECONSENT_DATETIME_PLACEHOLDER: {
    ko: "시간 선택",
    en: "Select time",
  },
  DOCUMENT_ECONSENT_EDIT_SCHEDULE_DIALOG_HEADER: {
    ko: "Edit eConsent",
    en: "Edit eConsent",
  },
  DOCUMENT_SEND_ECONSENT_ORGANIZATION_TITLE: {
    ko: "기관명",
    en: "Organization Name",
  },
  DOCUMENT_SEND_ECONSENT_ORGANIZATION_PLACEHOLDER: {
    ko: "전자동의를 요청하는 메일/문자에 표시됩니다.",
    en: "It is displayed in Email/SMS to request eConsent.",
  },

  DOCUMENT_SEND_ECONSENT_EMAIL_IMAGE_TITLE: {
    ko: "이메일 안내 이미지 {lang}",
    en: "Guide Image in Email {lang}",
  },
  DOCUMENT_SEND_ECONSENT_EMAIL_IMAGE_PLACEHOLDER: {
    ko: "이메일에 삽입할 이미지 파일을 선택해 주세요.",
    en: "Please Choose an image file to insert in Email.",
  },
  DOCUMENT_SEND_ECONSENT_SMS_CONTENT_TITLE: {
    ko: "연구 대상자 문자 내용",
    en: "SMS to Subjects",
  },
  DOCUMENT_SEND_ECONSENT_SMS_CONTENT_COMMON: {
    ko: "{ICF 이름} 전자동의 정보를 확인해 주세요. 아래의 링크를 누르면 전자동의 문서로 이동합니다.\n\n▶ 전자동의 문서에 서명하기 {링크}",
    en: "Please confirm {ICF Title} eConsent information. Click the link below to move to the eConsent document.\n\n▶ Sign eConsent document {Link}",
  },
  DOCUMENT_SEND_ECONSENT_SMS_CONTENT_PLACEHOLDER: {
    ko: "공통 문구 아래에 들어갈 문자 내용을 작성해 주세요.",
    en: "Please enter a SMS content below the common phrase.",
  },
  DOCUMENT_SEND_ECONSENT_SMS_CONTENT_DESCRIPTION: {
    ko: "최대 글자수 {maxLength}자 ({currentLength}/{maxLength})",
    en: "Maximum {maxLength} characters ({currentLength}/{maxLength})",
  },
  DOCUMENT_SEND_ECONSENT_SCHEDULE_SEND_SUCC: {
    ko: "전자 동의서 전송이 예약되었습니다.",
    en: "eConsent is scheduled to be sent.",
  },
  DOCUMENT_SEND_SCHEDULED_ECONSENT_DELAY_DESCRIPTION: {
    ko: "서버 상황에 따라 설정된 예약 발송 시간보다 약간 지연될 수 있습니다.",
    en: "Depending on server conditions, there may be a slight delay from the set scheduled send time.",
  },
  DOCUMENT_SEND_SCHEDULED_ECONSENT_PAST_TIME_SETTING: {
    ko: "예약 발송 시간은 과거 시간으로 설정이 불가능합니다.",
    en: "It is unavailable to set scheduled time as the past time.",
  },
  DOCUMENT_SEND_SCHEDULED_ECONSENT_INNER_FIVE_MINUTE_SETTING: {
    ko: "현재 시간으로부터 5분 이내 설정은 불가능합니다.",
    en: "It is unavailable to set scheduled time within 5 mins from the current time.",
  },
  DOCUMENT_SEND_CANCEL_SCHEDULED_ECONSENT_DIALOG_DESCRIPTION: {
    ko: "예약 발송을 취소하시겠습니까?",
    en: "Are you sure you want to cancel a scheduled send?",
  },
  DOCUMENT_SEND_CANCEL_SCHEDULED_ECONSENT_SUCCESS: {
    ko: "예약 발송 취소가 완료되었습니다.",
    en: "Scheduled send has been canceled.",
  },
  DOCUMENT_SEND_EDIT_SCHEDULED_ECONSENT_SUCCESS: {
    ko: "예약 발송이 수정되었습니다.",
    en: "Changes have been saved.",
  },
  DOCUMENT_SEND_SCHEDULED_ECONSENT_SUBSCRIPTION_EXPIRED_DESC: {
    ko: "설정된 예약 발송일에는 사용 중인 Docs Plan이 만료 예정으로 발송이 불가능합니다.",
    en: "Subscription will be expired on the scheduled send date and cannot be dispatched.",
  },
  DOCUMENT_SEND_SCHEDULED_ECONSENT_MOVE_TO_SUBSCRIPTION_PAGE: {
    ko: "구독 페이지로 이동하시겠습니까?",
    en: "Are you want to move a subscription page?",
  },
  DOCUMENT_SEND_ECONSENT_TITLE_SUFFIX_KO: {
    ko: "(한)",
    en: "(KR)",
  },
  DOCUMENT_SEND_ECONSENT_TITLE_SUFFIX_EN: {
    ko: "(영)",
    en: "(EN)",
  },
  DOCUMENT_ECONSENT_REQUEST_DOWNLOAD_DOCUMENT_SUCC: {
    ko: "전자동의 완료 문서 생성이 요청되었습니다.",
    en: "eConsent document download has been requested.",
  },
  DOCUMENT_ECONSENT_REQUEST_DOWNLOAD_DOCUMENT_FAIL: {
    ko: "전자동의 완료 문서 생성 요청에 실패했습니다. ({message})",
    en: "Failed to request eConsent document download. ({message})",
  },
  DOCUMENT_ECONSENT_DONOR: {
    ko: "기증자",
    en: "Donor",
  },
  DOCUMENT_ECONSENT_AGENT: {
    ko: "법정 대리인",
    en: "Agent",
  },
  DOCUMENT_ECONSENT_AGENT_ACTIVE: {
    ko: "법정 대리인 활성화",
    en: "Activate Agent",
  },
  DOCUMENT_ECONSENT_AGENT_SIGN_SIGNATURE: {
    ko: "법정 대리인 서명",
    en: "Agent Signature",
  },
  DOCUMENT_ECONSENT_TEXT_INPUT_FIELD_TITLE: {
    ko: "텍스트",
    en: "Text",
  },
  DOCUMENT_ECONSENT_TEXT_INPUT_FIELD_LABEL: {
    ko: "가이드 입력란",
    en: "Input Guide",
  },
  DOCUMENT_ECONSENT_TEXT_INPUT_FIELD_PLACEHOLDER: {
    ko: "가이드를 입력해주세요.",
    en: "Enter input guide.",
  },
  DOCUMENT_ECONSENT_TEXT_INPUT_FIELD_HELPER_LABEL: {
    ko: "작성 예시) 이름을 입력해 주세요.",
    en: "e.g. Please enter your name.",
  },
  DOCUMENT_ECONSENT_TEXT_FREE_FIELD_LABEL: {
    ko: "자유 텍스트 입력",
    en: "Free Text",
  },
  DOCUMENT_ECONSENT_TEXT_DATE_FIELD_LABEL: {
    ko: "날짜 입력 ({format})",
    en: "Date Input ({format})",
  },
  DOCUMENT_ECONSENT_SINGLE_SELECT_FIELD_TITLE: {
    ko: "단일 선택",
    en: "Single Select",
  },
  DOCUMENT_ECONSENT_DROPDOWN_FIELD_TITLE: {
    ko: "드롭다운",
    en: "Dropdown",
  },
  DOCUMENT_ECONSENT_DROPDOWN_FILED_LABEL: {
    ko: "드롭다운 옵션",
    en: "Dropdown option",
  },
  DOCUMENT_ECONSENT_DROPDOWN_FIELD_PLACEHOLDER: {
    ko: ";으로 옵션을 구분",
    en: "Separated options by semicolon",
  },
  DOCUMENT_ECONSENT_DROPDOWN_FIELD_HELPER_LABEL: {
    ko: "작성 예시) 옵션1;옵션2;옵션3",
    en: "e.g. op1;op2;op3",
  },
  DOCUMENT_ECONSENT_DROPDOWN_MISSING_LABEL: {
    ko: "가이드 입력란",
    en: "Input Guide",
  },
  DOCUMENT_ECONSENT_DROPDOWN_MISSING_PLACEHOLDER: {
    ko: "작성 예시) 지역번호를 선택해 주세요.",
    en: "e.g. Please select your area.",
  },
  DOCUMENT_ECONSENT_DROPDOWN_OPTION_ITEM_MAX_COUNT: {
    ko: "옵션은 최대 {count}개까지 입력할 수 있습니다.",
    en: "You can enter up to {count} options.",
  },
  DOCUMENT_ECONSENT_ADDRESS_FIELD_TITLE: {
    ko: "주소",
    en: "Address",
  },
  DOCUMENT_ECONSENT_ADD_ITEM_GROUP: {
    ko: "입력 항목 추가",
    en: "Additional fields",
  },
  DOCUMENT_ECONSENT_SELECT_TEXT_FIELD_OPTION_LABEL: {
    ko: "입력 유형 선택",
    en: "Select Input Type",
  },
  DOCUMENT_ECONSENT_SELECT_TEXT_FIELD_OPTION_PLACEHOLDER: {
    ko: "입력 유형을 선택해 주세요.",
    en: "Please select the input type.",
  },
  DOCUMENT_ECONSENT_CONSENT: {
    ko: "단일 선택",
    en: "Single Select",
  },
  DOCUMENT_ECONSENT_CONSENT_ITEM: {
    ko: "단일 선택",
    en: "Single Select",
  },
  DOCUMENT_ECONSENT_ADD_CONSENT_ITEM: {
    ko: "동의 내용 항목 추가",
    en: "Add Consent Item",
  },
  DOCUMENT_ECONSENT_RESPONSIVE_ITEM_ALT_TEXT_PLACEHOLDER: {
    ko: "선택 시 표시되는 텍스트입니다.",
    en: "Text displayed upon selection",
  },
  DOCUMENT_ECONSENT_SELECT_DATE_PLACEHOLDER: {
    ko: "날짜를 선택해 주세요.",
    en: "Please select a date.",
  },
  DOCUMENT_ECONSENT_DATE: {
    ko: "날짜",
    en: "Date",
  },
  DOCUMENT_ECONSENT_SELECT_DATE_FORMAT_LABEL: {
    ko: "날짜 형식",
    en: "Date Format",
  },
  DOCUMENT_ECONSENT_DATE_MISSING_LABEL: {
    ko: "가이드 입력란",
    en: "Input Guide",
  },
  DOCUMENT_ECONSENT_DATE_MISSING_PLACEHOLDER: {
    ko: "작성 예시) 생년월일을 입력해 주세요.",
    en: "e.g. Please enter your birth date.",
  },
  DOCUMENT_ECONSENT_ADDRESS_FIELD_LABEL: {
    ko: "입력 유형",
    en: "Address Input",
  },
  DOCUMENT_ECONSENT_ADDRESS_FIELD_PLACEHOLDER: {
    ko: "도로명 주소",
    en: "Please enter the address.",
  },
  DOCUMENT_ECONSENT_ADDRESS_MISSING_LABEL: {
    ko: "가이드 입력란",
    en: "Input Guide",
  },
  DOCUMENT_ECONSENT_ADDRESS_MISSING_PLACEHOLDER: {
    ko: "작성 예시) 주소를 입력해 주세요.",
    en: "e.g. Please enter your address.",
  },
  DOCUMENT_ECONSENT_FOLLOW_WRITING_FIELD_TITLE: {
    ko: "따라쓰기",
    en: "Follow Writing",
  },
  DOCUMENT_ECONSENT_FOLLOW_WRITING_FIELD_LABEL: {
    ko: "따라 쓸 내용",
    en: "Follow Writing Content",
  },
  DOCUMENT_ECONSENT_FOLLOW_WRITING_FIELD_PLACEHOLDER: {
    ko: "따라 쓸 내용을 입력해 주세요",
    en: "Enter the content to follow",
  },
  DOCUMENT_ECONSENT_FOLLOW_WRITING_FIELD_MISSING: {
    ko: "따라쓰기 입력",
    en: "Please enter the content to follow.",
  },
  DOCUMENT_ECONSENT_FOLLOW_WRITING_FIELD_FAILED_IDENTIFY_SIGNATURE: {
    ko: "따라쓰기를 식별할 수 없습니다. 더 크게 입력해 주세요.",
    en: "Failed to identify follow writing. Please enter larger.",
  },
  DOCUMENT_ECONSENT_TEMPLATE: {
    ko: "서명 정보 템플릿",
    en: "Signature Template",
  },
  DOCUMENT_ECONSENT_TEMPLATE_BUTTON: {
    ko: "서명 정보 템플릿",
    en: "Signature Template",
  },
  DOCUMENT_ECONSENT_TEMPLATE_DIALOG_TITLE: {
    ko: "서명 정보 템플릿 추가",
    en: "Add Signature Template",
  },
  DOCUMENT_ECONSENT_TEMPLATE_DIALOG_DESCRIPTION: {
    ko: "서명 정보 템플릿을 구성해 주세요.",
    en: "Please configure the signature template.",
  },
  DOCUMENT_ECONSENT_TEMPLATE_MISC_BUTTON: {
    ko: "Reset",
    en: "Reset",
  },
  DOCUMENT_NO_SUBJECT_TEMPLATE: {
    ko: "템플릿에 연구 대상자가 없습니다.",
    en: "There is no subject in the template",
  },
  DOCUMENT_FOLDER_INVALID_ACCESS: {
    ko: "접근할 수 없는 페이지입니다.",
    en: "Cannot access this page.",
  },
  DOCUMENT_FOLDER_INVALID_ACCESS_DESCRIPTION: {
    ko: "권한이 부여된 계정으로 접속하시거나\nURL을 보낸 담당자에게 권한을 요청해주세요.",
    en: "Please log in with an authorized account or request\naccess from the person who sent you the URL.",
  },
  DOCUMENT_CANCELED_SIGN: {
    ko: "서명이 취소된 문서 입니다.",
    en: "e-Sign has been canceled.",
  },
  DOCUMENT_CANCELED_SIGN_DESCRIPTION: {
    ko: "문서를 확인하려면\n서명 요청을 보낸 담당자에게 문의해주세요.",
    en: "To view this document,\nplease contact the person who sent the request.",
  },
  DOCUMENT_ECONSENT_INVESTOR_AUTO_FILL_CHECKBOX: {
    ko: "사용자 정보 자동 입력",
    en: "Enter user information",
  },
  DOCUMENT_ECONSENT_STUDY_CREATED: {
    ko: "스터디가 생성되었습니다.",
    en: "Study bas been created.",
  },
  DOCUMENT_ECONSENT_INVALID_TEMPLATE: {
    ko: "모든 데이터 또는 템플릿이 올바른지 확인해주세요.",
    en: "Please ensure the template or all values are valid.",
  },
  DOCUMENT_ECONSENT_FILED_TO_FILL_BUTTON: {
    ko: "필수 입력 항목 ({count}/{total})",
    en: "Fields to fill ({count}/{total})",
  },
  DOCUMENT_ECONSENT_COMPLETE_BUTTON: {
    ko: "전자 동의서 제출 ({count}/{total})",
    en: "Complete e-consent ({count}/{total})",
  },
  DOCUMENT_ECONSENT_CANCEL_BULK_SUCC: {
    ko: "eConsent 서명 취소 요청이 완료되었습니다. ({total}건 중 {complete}건)",
    en: "eConsent signature cancellation requests completed. ({complete} out of {total})",
  },
  DOCUMENT_SIGN_EMAIL_VALIDATION_INVALID: {
    ko: "올바른 이메일을 입력해 주세요.",
    en: "Please enter a valid email address.",
  },
  DOCUMENT_SIGN_EMAIL_VERIFICATION_CODE_INVALID: {
    ko: "인증번호가 올바르지 않습니다.",
    en: "The code is invalid.",
  },
  DOCUMENT_SIGN_SIGNATURE_ANIMATION_DESC: {
    ko: "여기에 서명",
    en: "Sign here",
  },
  DOCUMENT_SIGN_SIGNATURE_PAD_DESC: {
    ko: "여기에 서명하세요",
    en: "Draw signature here",
  },
  DOCUMENT_SIGN_DROPDOWN_MARKER_PLACEHOLDER: {
    ko: "선택해 주세요",
    en: "Select Option",
  },
  DOCUMENT_SIGN_SIGNEE_NAME_LABEL: {
    ko: "서명자 이름",
    en: "Signee name",
  },
  DOCUMENT_SIGN_SIGNEE_EMAIL_LABEL: {
    ko: "서명자 이메일",
    en: "Signee email",
  },
  DOCUMENT_SIGN_SIGNEE_JOB_LABEL: {
    ko: "직위/직책",
    en: "Job title",
  },
  DOCUMENT_SIGN_SIGNEE_COMPANY_LABEL: {
    ko: "회사 이름",
    en: "Company name",
  },
  DOCUMENT_ECONSENT_EMAIL_IMAGE_DESCRIPTION: {
    ko: "이 이미지는 이메일에 삽입됩니다.",
    en: "The image will be inserted in Email",
  },
  DOCUMENT_SIGN_TITLE_INPUT_LABEL: {
    ko: "전자서명 제목",
    en: "Title",
  },
  DOCUMENT_SIGN_TITLE_INPUT_PLACEHOLDER: {
    ko: "제목을 입력하세요",
    en: "Enter title",
  },
  DOCUMENT_SIGN_COMPLETE_BUTTON: {
    ko: "전자서명 완료하기 ({count}/{total})",
    en: "Complete E-Sign ({count}/{total})",
  },
  DOCUMENT_ECONSENT_SUBJECT_NAME_INPUT_LABEL: {
    ko: "이름",
    en: "Name",
  },
  DOCUMENT_ECONSENT_SUBJECT_NAME_INPUT_PLACEHOLDER: {
    ko: "이름을 입력하세요",
    en: "Enter name",
  },
  DOCUMENT_ECONSENT_SUBJECT_EMAIL_INPUT_LABEL: {
    ko: "이메일",
    en: "Email",
  },
  DOCUMENT_ECONSENT_SUBJECT_EMAIL_INPUT_PLACEHOLDER: {
    ko: "이메일을 입력하세요",
    en: "Enter email",
  },
  DOCUMENT_ECONSENT_SUBJECT_PHONE_INPUT_LABEL: {
    ko: "전화번호 (선택)",
    en: "Phone number (optional)",
  },
  DOCUMENT_ECONSENT_SUBJECT_PHONE_INPUT_PLACEHOLDER: {
    ko: "전화번호를 입력하세요",
    en: "Enter phone number",
  },
  DOCUMENT_ECONSENT_SUBJECT_PHONE_INPUT_INVALID_DESCRIPTION: {
    ko: "유효하지 않은 전화번호입니다.",
    en: "Invalid phone number.",
  },
  DOCUMENT_SIGN_RETURN_LIST_CONFIRM_TITLE: {
    ko: "정말 나가시겠습니까?",
    en: "Are you sure you want to exit?",
  },
  DOCUMENT_SIGN_RETURN_LIST_CONFIRM_DESCRIPTION: {
    ko: "나가면 설정값이 모두 초기화됩니다.",
    en: "If you exit, all settings will be reset.",
  },
  DOCUMENT_SIGN_CLOSE_FIELD_SETTING_TITLE: {
    ko: "설정을 종료하시겠습니까?",
    en: "Do you want to end the settings?",
  },
  DOCUMENT_SIGN_CLOSE_FIELD_SETTING_DESCRIPTION: {
    ko: "설정을 종료하면 설정값이 모두 삭제됩니다.",
    en: "If you end settings, all settings will be deleted.",
  },
  DOCUMENT_SIGN_REFERRER_SEGMENT_TITLE: {
    ko: "참조자",
    en: "CC",
  },
  DOCUMENT_SIGN_SIGNER_SEGMENT_TITLE: {
    ko: "서명자",
    en: "Signee",
  },
  DOCUMENT_SIGN_REFERRER_NOT_EXISTS_DESCRIPTION: {
    ko: "추가된 참조자가 없습니다.",
    en: "No CC recipients added.",
  },
  DOCUMENT_SIGN_REFERRER_SECTION_TITLE: {
    ko: "참조 ({amount}/{limit})",
    en: "CC ({amount}/{limit})",
  },
  DOCUMENT_SIGN_REFERRER_ADD_BUTTON: {
    ko: "참조자 추가",
    en: "Add CC",
  },
  DOCUMENT_SIGN_REFERRER_NAME_LABEL: {
    ko: "이름",
    en: "Name",
  },
  DOCUMENT_SIGN_REFERRER_EMAIL_LABEL: {
    ko: "이메일",
    en: "Email",
  },
  DOCUMENT_SIGN_REFERRER_COMPANY_LABEL: {
    ko: "소속(회사)",
    en: "Company",
  },
  DOCUMENT_SIGN_REFERRER_JOB_LABEL: {
    ko: "직위/직책",
    en: "Job title",
  },
  DOCUMENT_SIGN_REFERRER_NAME_PLACEHOLDER: {
    ko: "이름 입력",
    en: "Enter name",
  },
  DOCUMENT_SIGN_REFERRER_EMAIL_PLACEHOLDER: {
    ko: "이메일 입력",
    en: "Enter email",
  },
  DOCUMENT_SIGN_REFERRER_COMPANY_PLACEHOLDER: {
    ko: "회사 입력",
    en: "Enter company name",
  },
  DOCUMENT_SIGN_REFERRER_JOB_PLACEHOLDER: {
    ko: "직위/직책 입력",
    en: "Enter job title",
  },
  DOCUMENT_SIGN_REFERRER_INPUT_LENGTH_EXCEED_WARN_DESCRIPTION: {
    ko: "참조자의 {attribute}은(는)  {limit}자 이상 입력할 수 없습니다.",
    en: "The field {attribute} is not allowed more than {limit} characters.",
  },
  DOCUMENT_SIGN_REFERRER_INPUT_REQUIRED_WARN_DESCRIPTION: {
    ko: "{attribute}은(는) 필수 입력값 입니다.",
    en: "{attribute} is required field.",
  },
  DOCUMENT_SIGN_NAME_SETTING_DIALOG_TITLE: {
    ko: "전자서명 제목",
    en: "E-Sign Title",
  },
  DOCUMENT_SIGN_NAME_SETTING_DIALOG_INITIAL_TITLE: {
    ko: "전자서명 시작",
    en: "Start E-Sign",
  },
  DOCUMENT_SIGN_NAME_SETTING_DIALOG_DESCRIPTION: {
    ko: "전자서명의 제목을 설정해 주세요.",
    en: "Please enter title of E-Sign.",
  },
  DOCUMENT_SIGN_TITLE_MAX_LENGTH_EXCEED: {
    ko: "전자서명의 제목은 {limit}자를 초과할 수 없습니다.",
    en: "The title of E-Sign is not allowed more than {limit} characters.",
  },
  DOCUMENT_SIGN_REQUEST_REASON_MAX_LENGTH_EXCEED: {
    ko: "전자서명의 서명 사유는 {limit}자를 초과할 수 없습니다.",
    en: "The reason of E-Sign is not allowed more than {limit} characters.",
  },
  DOCUMENT_SIGN_NAME_SETTING_DIALOG_TITLE_LABEL: {
    ko: "제목",
    en: "Title",
  },
  DOCUMENT_SIGN_NAME_SETTING_DIALOG_TITLE_PLACEHOLDER: {
    ko: "제목 입력",
    en: "Enter title",
  },
  FORM_INVALID: {
    ko: "유효하지 않은 입력값입니다.",
    en: "This field is invalid.",
  },
  FORM_REQUIRED: {
    ko: "필수 입력값입니다.",
    en: "This field is required.",
  },
  FORM_EMAIL_CONTAIN_KOREAN: {
    ko: "올바른 이메일 주소를 입력해주세요. 이메일은 영문과 특수 문자(@, . 등)만 사용할 수 있습니다.",
    en: "Please enter a valid email address. Only English letters and special characters (@, . etc.) are allowed.",
  },
  DOCUMENT_SIGN_SUMMARIZE_DIALOG_TITLE: {
    ko: "전자서명 요청",
    en: "E-Sign Request",
  },
  DOCUMENT_SIGN_SUMMARIZE_DIALOG_DESCRIPTION: {
    ko: "서명 요청전 입력 정보를 확인해주세요.",
    en: "Please review the details before making a request.",
  },
  DOCUMENT_SIGN_SUMMARIZE_DIALOG_EMAIL_VERIFICATION: {
    ko: "이메일 인증",
    en: "Email verification",
  },
  DOCUMENT_SIGN_SUMMARIZE_DIALOG_IDENTITY_VERIFICATION: {
    ko: "본인 인증",
    en: "Identity verification",
  },
  DOCUMENT_SIGN_SUMMARIZE_DIALOG_NONE_VERIFICATION: {
    ko: "미설정",
    en: "OFF",
  },
  DOCUMENT_SIGN_SUMMARIZE_DIALOG_VERIFICATION_LABEL: {
    ko: "인증 설정",
    en: "Verification settings",
  },
  DOCUMENT_SIGN_SUMMARIZE_DIALOG_REQUEST_INFO_LABEL: {
    ko: "요청 정보",
    en: "Request details",
  },
  DOCUMENT_SIGN_FIELD_SETTING_RESET_BUTTON: {
    ko: "모두 지우기",
    en: "Clear All",
  },
  DOCUMENT_SIGN_STATUS_REFERRER_HIDE_TEXT_BUTTON: {
    ko: "숨기기",
    en: "Hide",
  },
  DOCUMENT_SIGN_STATUS_REFERRER_LABEL: {
    ko: "참조",
    en: "CC",
  },
  DOCUMENT_SIGN_LIST_TABLE_TITLE_COLUMN: {
    ko: "제목",
    en: "Title",
  },
  DOCUMENT_SIGN_LIST_TABLE_UUID_COLUMN: {
    ko: "서명문서 식별자",
    en: "Document Id",
  },
  DOCUMENT_SIGN_LIST_TABLE_SIGNER_COLUMN: {
    ko: "서명자",
    en: "Signee",
  },
  DOCUMENT_SIGN_LIST_TABLE_REFERRER_COLUMN: {
    ko: "참조자",
    en: "CC",
  },
  DOCUMENT_SIGN_LIST_TABLE_SIGN_STATUS_COLUMN: {
    ko: "서명 상태",
    en: "Status",
  },
  DOCUMENT_SIGN_LIST_TABLE_UPDATE_AT_COLUMN: {
    ko: "업데이트 일자",
    en: "Update At",
  },
  DOCUMENT_SIGN_ADDITIONAL_MESSAGE_DESCRIPTION: {
    ko: "서명자는 최대 {limit}명까지 추가할 수 있습니다.",
    en: "A maximum of {limit} signees can be added.",
  },
  DOCUMENT_SIGN_DUPLICATE_EMAIL_WARN: {
    ko: "서명자에 중복된 이메일이 있습니다. ({emails})",
    en: "Duplicate signer emails found. ({emails})",
  },
};

MvnCodeInitiate(DOCS_DOCUMENT_LANG);
